module.exports = __webpack_public_path__ + "static/media/ic-dy-man03.04e3ae10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-dy-man03.png
// module id = 271
// module chunks = 2